<div class="page-grid-container">
  <div class="search-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Search pages..." [formControl]="searchControl" />
    </mat-form-field>
  </div>

  <div class="chips-section">
    <mat-chip-list [selectable]="true" [multiple]="false">
      <mat-chip [selected]="selectedChip === 'all'" (click)="onChipSelect('all')"> All </mat-chip>
      <mat-chip
        *ngFor="let section of sections"
        [selected]="selectedChip === section.slug"
        (click)="onChipSelect(section.slug)"
      >
        {{ section.name }}
      </mat-chip>
    </mat-chip-list>
  </div>

  <div class="grid-section">
    <div class="thumbnail-grid">
      <div
        class="page-thumbnail"
        *ngFor="let page of filteredPages"
        [style.aspect-ratio]="getThumbnailAspectRatio(page)"
        [style.max-width]="getThumbnailMaxWidth(page)"
        (click)="onPageClick(page)"
      >
        <img [src]="page.thumbnail" [alt]="page.name" width="100%" />
      </div>
    </div>

    <div class="empty-state" *ngIf="filteredPages.length === 0">
      <p>No pages matching the current filters</p>
    </div>
  </div>
</div>
